import React from 'react';
import cn from 'classnames';

import SparkSVG from '@/icons/spark.svg';
import LogoSVG from '@/icons/logo.svg';

import s from './badge.module.scss';

interface BasicTemplateProps extends React.HTMLAttributes<HTMLElement> {
    children?: React.ReactNode;
};

export const BadgeTemplate: React.FC<BasicTemplateProps> = (props) => {
    return (
        <main
            className={s['basic-template']}
        >
            <section className={s['basic-template__header']}>
                <img src={SparkSVG} />
            </section>
            <section className={s['basic-template__content']}>
                {props.children}
            </section>
            <section className={s['basic-template__footer']}>
                <img src={LogoSVG} />
            </section>
        </main>
    );
};
